import { render, staticRenderFns } from "./BaseFieldSelect.vue?vue&type=template&id=241385f0&"
import script from "./BaseFieldSelect.vue?vue&type=script&lang=ts&"
export * from "./BaseFieldSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports